import { Component, Input } from '@angular/core';
import { LabelColor } from '@app/pcs/models';
import { getColorForLabel } from '@app/pcs/util/user-label';
import { hasValue } from '@util';
import * as R from 'ramda';

@Component({
  selector: 'pcs-label-item',
  templateUrl: './label-item.component.html',
  styleUrls: ['./label-item.component.scss']
})

export class LabelItemComponent {
  @Input() id = '';
  @Input() iconLeft;
  @Input() iconRight;
  @Input() name = '';
  @Input() description = '';
  @Input() labelSharedWithUser = false;
  @Input() creatorUser = '';
  @Input() color: LabelColor;

  get labelItemClasses() {
    return {
      [getColorForLabel(this.color).value]: true
    };
  }

  get title() {
    return hasValue(this.description)
      ? R.join(' - ', [this.name, this.description])
      : this.name;
  }
}
